// src/components/Header.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import './Header.css';

const Header = ({ onToggleSidebar }) => {
  const { userName, userType, logout } = useAuthStore();
  const navigate = useNavigate();

  const isGeneral = userType === '一般';

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const handleLogoClick = () => {
    if (userType === 'admin') navigate('/enduser/usermanagement');
    else if (userType === 'enduser') navigate('/enduser/usermanagement');
    else navigate('/enduser/usermanagement');
  };

  return (
    <div className="header">
      {!isGeneral && (
        <button className="hamburger" onClick={onToggleSidebar} aria-label="メニュー">
          ☰
        </button>
      )}

      <h1 className="logo-text" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        {/* <img src="/event_plus_logo.png" alt="予定PLUS ロゴ" className="logo-image" /> */}
        ドッグショー
      </h1>

      <div className="user-info">
        {userName ? (
          <div className="login-status">
            <span>ログイン：{userName} 様</span>
            <button className="logout-button" onClick={handleLogout}>
              ログアウト
            </button>
          </div>
        ) : (
          <p>ゲスト</p>
        )}
      </div>
    </div>
  );
};

export default Header;
